export const FETCH_REPORTS_REQUEST = 'FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILURE = 'FETCH_REPORTS_FAILURE';
export const CLEAR_REPORTS_DATA = 'CLEAR_REPORTS_DATA';

export interface FetchReportsRequestAction {
  type: typeof FETCH_REPORTS_REQUEST;
  payload: {
    factories: number[];
    columns: number[];
    month?: number;
    year?: string;
    subdivisions?: number[];
    group?: number;
  };
}

export interface FetchReportsSuccessAction {
  type: typeof FETCH_REPORTS_SUCCESS;
  payload: any;
}

export interface FetchReportsFailureAction {
  type: typeof FETCH_REPORTS_FAILURE;
  payload: string;
}

export interface ClearReportsDataAction {
  type: typeof CLEAR_REPORTS_DATA;
}

export type ReportsActionTypes =
  | FetchReportsRequestAction
  | FetchReportsSuccessAction
  | FetchReportsFailureAction
  | ClearReportsDataAction;

export const fetchReportsRequest = (
  factories: number[],
  columns: number[],
  month?: number,
  year?: string,
  subdivisions?: number[],
  group?: number
): FetchReportsRequestAction => ({
  type: FETCH_REPORTS_REQUEST,
  payload: { factories, columns, month, year, subdivisions, group },
});

export const fetchReportsSuccess = (data: any): FetchReportsSuccessAction => ({
  type: FETCH_REPORTS_SUCCESS,
  payload: data,
});

export const fetchReportsFailure = (error: string): FetchReportsFailureAction => ({
  type: FETCH_REPORTS_FAILURE,
  payload: error,
});

export const clearReportsData = (): ClearReportsDataAction => ({
  type: CLEAR_REPORTS_DATA,
});
